module.exports = __webpack_public_path__ + "img/track.045c37eb.svg";